/*!
 * @kurkle/color v0.3.4
 * https://github.com/kurkle/color#readme
 * (c) 2024 Jukka Kurkela
 * Released under the MIT License
 */
function m(a) {
  return a + 0.5 | 0;
}
const d = (a, e, f) => Math.max(Math.min(a, f), e);
function l(a) {
  return d(m(a * 2.55), 0, 255);
}
function o(a) {
  return d(m(a * 255), 0, 255);
}
function g(a) {
  return d(m(a / 2.55) / 100, 0, 1);
}
function _(a) {
  return d(m(a * 100), 0, 100);
}
const c = { 0: 0, 1: 1, 2: 2, 3: 3, 4: 4, 5: 5, 6: 6, 7: 7, 8: 8, 9: 9, A: 10, B: 11, C: 12, D: 13, E: 14, F: 15, a: 10, b: 11, c: 12, d: 13, e: 14, f: 15 }, x = [..."0123456789ABCDEF"], $ = (a) => x[a & 15], E = (a) => x[(a & 240) >> 4] + x[a & 15], p = (a) => (a & 240) >> 4 === (a & 15), R = (a) => p(a.r) && p(a.g) && p(a.b) && p(a.a);
function A(a) {
  var e = a.length, f;
  return a[0] === "#" && (e === 4 || e === 5 ? f = {
    r: 255 & c[a[1]] * 17,
    g: 255 & c[a[2]] * 17,
    b: 255 & c[a[3]] * 17,
    a: e === 5 ? c[a[4]] * 17 : 255
  } : (e === 7 || e === 9) && (f = {
    r: c[a[1]] << 4 | c[a[2]],
    g: c[a[3]] << 4 | c[a[4]],
    b: c[a[5]] << 4 | c[a[6]],
    a: e === 9 ? c[a[7]] << 4 | c[a[8]] : 255
  })), f;
}
const U = (a, e) => a < 255 ? e(a) : "";
function V(a) {
  var e = R(a) ? $ : E;
  return a ? "#" + e(a.r) + e(a.g) + e(a.b) + U(a.a, e) : void 0;
}
const W = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function P(a, e, f) {
  const r = e * Math.min(f, 1 - f), n = (t, s = (t + a / 30) % 12) => f - r * Math.max(Math.min(s - 3, 9 - s, 1), -1);
  return [n(0), n(8), n(4)];
}
function H(a, e, f) {
  const r = (n, t = (n + a / 60) % 6) => f - f * e * Math.max(Math.min(t, 4 - t, 1), 0);
  return [r(5), r(3), r(1)];
}
function q(a, e, f) {
  const r = P(a, 1, 0.5);
  let n;
  for (e + f > 1 && (n = 1 / (e + f), e *= n, f *= n), n = 0; n < 3; n++)
    r[n] *= 1 - e - f, r[n] += e;
  return r;
}
function L(a, e, f, r, n) {
  return a === n ? (e - f) / r + (e < f ? 6 : 0) : e === n ? (f - a) / r + 2 : (a - e) / r + 4;
}
function F(a) {
  const e = a.r / 255, f = a.g / 255, r = a.b / 255, n = Math.max(e, f, r), t = Math.min(e, f, r), s = (n + t) / 2;
  let i, u, b;
  return n !== t && (b = n - t, u = s > 0.5 ? b / (2 - n - t) : b / (n + t), i = L(e, f, r, b, n), i = i * 60 + 0.5), [i | 0, u || 0, s];
}
function M(a, e, f, r) {
  return (Array.isArray(e) ? a(e[0], e[1], e[2]) : a(e, f, r)).map(o);
}
function X(a, e, f) {
  return M(P, a, e, f);
}
function N(a, e, f) {
  return M(q, a, e, f);
}
function K(a, e, f) {
  return M(H, a, e, f);
}
function T(a) {
  return (a % 360 + 360) % 360;
}
function j(a) {
  const e = W.exec(a);
  let f = 255, r;
  if (!e)
    return;
  e[5] !== r && (f = e[6] ? l(+e[5]) : o(+e[5]));
  const n = T(+e[2]), t = +e[3] / 100, s = +e[4] / 100;
  return e[1] === "hwb" ? r = N(n, t, s) : e[1] === "hsv" ? r = K(n, t, s) : r = X(n, t, s), {
    r: r[0],
    g: r[1],
    b: r[2],
    a: f
  };
}
function C(a, e) {
  var f = F(a);
  f[0] = T(f[0] + e), f = X(f), a.r = f[0], a.g = f[1], a.b = f[2];
}
function Q(a) {
  if (!a)
    return;
  const e = F(a), f = e[0], r = _(e[1]), n = _(e[2]);
  return a.a < 255 ? `hsla(${f}, ${r}%, ${n}%, ${g(a.a)})` : `hsl(${f}, ${r}%, ${n}%)`;
}
const k = {
  x: "dark",
  Z: "light",
  Y: "re",
  X: "blu",
  W: "gr",
  V: "medium",
  U: "slate",
  A: "ee",
  T: "ol",
  S: "or",
  B: "ra",
  C: "lateg",
  D: "ights",
  R: "in",
  Q: "turquois",
  E: "hi",
  P: "ro",
  O: "al",
  N: "le",
  M: "de",
  L: "yello",
  F: "en",
  K: "ch",
  G: "arks",
  H: "ea",
  I: "ightg",
  J: "wh"
}, S = {
  OiceXe: "f0f8ff",
  antiquewEte: "faebd7",
  aqua: "ffff",
  aquamarRe: "7fffd4",
  azuY: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "0",
  blanKedOmond: "ffebcd",
  Xe: "ff",
  XeviTet: "8a2be2",
  bPwn: "a52a2a",
  burlywood: "deb887",
  caMtXe: "5f9ea0",
  KartYuse: "7fff00",
  KocTate: "d2691e",
  cSO: "ff7f50",
  cSnflowerXe: "6495ed",
  cSnsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "ffff",
  xXe: "8b",
  xcyan: "8b8b",
  xgTMnPd: "b8860b",
  xWay: "a9a9a9",
  xgYF: "6400",
  xgYy: "a9a9a9",
  xkhaki: "bdb76b",
  xmagFta: "8b008b",
  xTivegYF: "556b2f",
  xSange: "ff8c00",
  xScEd: "9932cc",
  xYd: "8b0000",
  xsOmon: "e9967a",
  xsHgYF: "8fbc8f",
  xUXe: "483d8b",
  xUWay: "2f4f4f",
  xUgYy: "2f4f4f",
  xQe: "ced1",
  xviTet: "9400d3",
  dAppRk: "ff1493",
  dApskyXe: "bfff",
  dimWay: "696969",
  dimgYy: "696969",
  dodgerXe: "1e90ff",
  fiYbrick: "b22222",
  flSOwEte: "fffaf0",
  foYstWAn: "228b22",
  fuKsia: "ff00ff",
  gaRsbSo: "dcdcdc",
  ghostwEte: "f8f8ff",
  gTd: "ffd700",
  gTMnPd: "daa520",
  Way: "808080",
  gYF: "8000",
  gYFLw: "adff2f",
  gYy: "808080",
  honeyMw: "f0fff0",
  hotpRk: "ff69b4",
  RdianYd: "cd5c5c",
  Rdigo: "4b0082",
  ivSy: "fffff0",
  khaki: "f0e68c",
  lavFMr: "e6e6fa",
  lavFMrXsh: "fff0f5",
  lawngYF: "7cfc00",
  NmoncEffon: "fffacd",
  ZXe: "add8e6",
  ZcSO: "f08080",
  Zcyan: "e0ffff",
  ZgTMnPdLw: "fafad2",
  ZWay: "d3d3d3",
  ZgYF: "90ee90",
  ZgYy: "d3d3d3",
  ZpRk: "ffb6c1",
  ZsOmon: "ffa07a",
  ZsHgYF: "20b2aa",
  ZskyXe: "87cefa",
  ZUWay: "778899",
  ZUgYy: "778899",
  ZstAlXe: "b0c4de",
  ZLw: "ffffe0",
  lime: "ff00",
  limegYF: "32cd32",
  lRF: "faf0e6",
  magFta: "ff00ff",
  maPon: "800000",
  VaquamarRe: "66cdaa",
  VXe: "cd",
  VScEd: "ba55d3",
  VpurpN: "9370db",
  VsHgYF: "3cb371",
  VUXe: "7b68ee",
  VsprRggYF: "fa9a",
  VQe: "48d1cc",
  VviTetYd: "c71585",
  midnightXe: "191970",
  mRtcYam: "f5fffa",
  mistyPse: "ffe4e1",
  moccasR: "ffe4b5",
  navajowEte: "ffdead",
  navy: "80",
  Tdlace: "fdf5e6",
  Tive: "808000",
  TivedBb: "6b8e23",
  Sange: "ffa500",
  SangeYd: "ff4500",
  ScEd: "da70d6",
  pOegTMnPd: "eee8aa",
  pOegYF: "98fb98",
  pOeQe: "afeeee",
  pOeviTetYd: "db7093",
  papayawEp: "ffefd5",
  pHKpuff: "ffdab9",
  peru: "cd853f",
  pRk: "ffc0cb",
  plum: "dda0dd",
  powMrXe: "b0e0e6",
  purpN: "800080",
  YbeccapurpN: "663399",
  Yd: "ff0000",
  Psybrown: "bc8f8f",
  PyOXe: "4169e1",
  saddNbPwn: "8b4513",
  sOmon: "fa8072",
  sandybPwn: "f4a460",
  sHgYF: "2e8b57",
  sHshell: "fff5ee",
  siFna: "a0522d",
  silver: "c0c0c0",
  skyXe: "87ceeb",
  UXe: "6a5acd",
  UWay: "708090",
  UgYy: "708090",
  snow: "fffafa",
  sprRggYF: "ff7f",
  stAlXe: "4682b4",
  tan: "d2b48c",
  teO: "8080",
  tEstN: "d8bfd8",
  tomato: "ff6347",
  Qe: "40e0d0",
  viTet: "ee82ee",
  JHt: "f5deb3",
  wEte: "ffffff",
  wEtesmoke: "f5f5f5",
  Lw: "ffff00",
  LwgYF: "9acd32"
};
function B() {
  const a = {}, e = Object.keys(S), f = Object.keys(k);
  let r, n, t, s, i;
  for (r = 0; r < e.length; r++) {
    for (s = i = e[r], n = 0; n < f.length; n++)
      t = f[n], i = i.replace(t, k[t]);
    t = parseInt(S[s], 16), a[i] = [t >> 16 & 255, t >> 8 & 255, t & 255];
  }
  return a;
}
let y;
function D(a) {
  y || (y = B(), y.transparent = [0, 0, 0, 0]);
  const e = y[a.toLowerCase()];
  return e && {
    r: e[0],
    g: e[1],
    b: e[2],
    a: e.length === 4 ? e[3] : 255
  };
}
const I = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function J(a) {
  const e = I.exec(a);
  let f = 255, r, n, t;
  if (e) {
    if (e[7] !== r) {
      const s = +e[7];
      f = e[8] ? l(s) : d(s * 255, 0, 255);
    }
    return r = +e[1], n = +e[3], t = +e[5], r = 255 & (e[2] ? l(r) : d(r, 0, 255)), n = 255 & (e[4] ? l(n) : d(n, 0, 255)), t = 255 & (e[6] ? l(t) : d(t, 0, 255)), {
      r,
      g: n,
      b: t,
      a: f
    };
  }
}
function z(a) {
  return a && (a.a < 255 ? `rgba(${a.r}, ${a.g}, ${a.b}, ${g(a.a)})` : `rgb(${a.r}, ${a.g}, ${a.b})`);
}
const v = (a) => a <= 31308e-7 ? a * 12.92 : Math.pow(a, 1 / 2.4) * 1.055 - 0.055, h = (a) => a <= 0.04045 ? a / 12.92 : Math.pow((a + 0.055) / 1.055, 2.4);
function G(a, e, f) {
  const r = h(g(a.r)), n = h(g(a.g)), t = h(g(a.b));
  return {
    r: o(v(r + f * (h(g(e.r)) - r))),
    g: o(v(n + f * (h(g(e.g)) - n))),
    b: o(v(t + f * (h(g(e.b)) - t))),
    a: a.a + f * (e.a - a.a)
  };
}
function Y(a, e, f) {
  if (a) {
    let r = F(a);
    r[e] = Math.max(0, Math.min(r[e] + r[e] * f, e === 0 ? 360 : 1)), r = X(r), a.r = r[0], a.g = r[1], a.b = r[2];
  }
}
function Z(a, e) {
  return a && Object.assign(e || {}, a);
}
function O(a) {
  var e = { r: 0, g: 0, b: 0, a: 255 };
  return Array.isArray(a) ? a.length >= 3 && (e = { r: a[0], g: a[1], b: a[2], a: 255 }, a.length > 3 && (e.a = o(a[3]))) : (e = Z(a, { r: 0, g: 0, b: 0, a: 1 }), e.a = o(e.a)), e;
}
function ee(a) {
  return a.charAt(0) === "r" ? J(a) : j(a);
}
class w {
  constructor(e) {
    if (e instanceof w)
      return e;
    const f = typeof e;
    let r;
    f === "object" ? r = O(e) : f === "string" && (r = A(e) || D(e) || ee(e)), this._rgb = r, this._valid = !!r;
  }
  get valid() {
    return this._valid;
  }
  get rgb() {
    var e = Z(this._rgb);
    return e && (e.a = g(e.a)), e;
  }
  set rgb(e) {
    this._rgb = O(e);
  }
  rgbString() {
    return this._valid ? z(this._rgb) : void 0;
  }
  hexString() {
    return this._valid ? V(this._rgb) : void 0;
  }
  hslString() {
    return this._valid ? Q(this._rgb) : void 0;
  }
  mix(e, f) {
    if (e) {
      const r = this.rgb, n = e.rgb;
      let t;
      const s = f === t ? 0.5 : f, i = 2 * s - 1, u = r.a - n.a, b = ((i * u === -1 ? i : (i + u) / (1 + i * u)) + 1) / 2;
      t = 1 - b, r.r = 255 & b * r.r + t * n.r + 0.5, r.g = 255 & b * r.g + t * n.g + 0.5, r.b = 255 & b * r.b + t * n.b + 0.5, r.a = s * r.a + (1 - s) * n.a, this.rgb = r;
    }
    return this;
  }
  interpolate(e, f) {
    return e && (this._rgb = G(this._rgb, e._rgb, f)), this;
  }
  clone() {
    return new w(this.rgb);
  }
  alpha(e) {
    return this._rgb.a = o(e), this;
  }
  clearer(e) {
    const f = this._rgb;
    return f.a *= 1 - e, this;
  }
  greyscale() {
    const e = this._rgb, f = m(e.r * 0.3 + e.g * 0.59 + e.b * 0.11);
    return e.r = e.g = e.b = f, this;
  }
  opaquer(e) {
    const f = this._rgb;
    return f.a *= 1 + e, this;
  }
  negate() {
    const e = this._rgb;
    return e.r = 255 - e.r, e.g = 255 - e.g, e.b = 255 - e.b, this;
  }
  lighten(e) {
    return Y(this._rgb, 2, e), this;
  }
  darken(e) {
    return Y(this._rgb, 2, -e), this;
  }
  saturate(e) {
    return Y(this._rgb, 1, e), this;
  }
  desaturate(e) {
    return Y(this._rgb, 1, -e), this;
  }
  rotate(e) {
    return C(this._rgb, e), this;
  }
}
export {
  w as Color,
  g as b2n,
  A as hexParse,
  V as hexString,
  X as hsl2rgb,
  Q as hslString,
  K as hsv2rgb,
  j as hueParse,
  N as hwb2rgb,
  d as lim,
  o as n2b,
  _ as n2p,
  D as nameParse,
  l as p2b,
  F as rgb2hsl,
  J as rgbParse,
  z as rgbString,
  C as rotate,
  m as round
};
//# sourceMappingURL=index.es360.js.map
